import { useEffect, useState } from "react";
import { apiGet, prettifyApiError } from "@/shared/api";

export type HealthState = { status: string; version: string };

export function useHealth(): { data: HealthState | null; error: string | null } {
  const [data, setData] = useState<HealthState | null>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    // Audit 2026-05-29: guard anti setState-post-unmount come gli altri hook
    // del progetto (useThreads/useOrders/useRitiriOggi). AbortController
    // cancella la fetch in volo; ``cancelled`` protegge il setState anche
    // se apiGet ignorasse il signal (es. mock nei test).
    const controller = new AbortController();
    let cancelled = false;
    apiGet<HealthState>("/health", { signal: controller.signal })
      .then((result) => {
        if (!cancelled) setData(result);
      })
      .catch((e: unknown) => {
        if (cancelled || controller.signal.aborted) return;
        // Audit 2026-05-29: errore comprensibile via prettifyApiError invece
        // del precedente String(e) grezzo (regola "errori in italiano").
        setError(prettifyApiError(e));
      });
    return () => {
      cancelled = true;
      controller.abort();
    };
  }, []);
  return { data, error };
}
